export default "__VITE_ASSET__CxX1XDMW__"